// Zweck: Gerätebereich mit bestehender Anmeldung und kontogebundenem Offlinebestand. Stand: 21.10.2026.
import { useEffect, useMemo, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import {
  getCachedProfile,
  getIdToken,
  wasAuthenticated,
} from '../services/googleAuthSession';
import { warehouseDevicesApi } from '../services/api/warehouseDevices';
import WarehouseDevicesScreen from './WarehouseDevicesScreen';

export default function WarehouseDevicesPage() {
  const { user, isLoading } = useAuth();
  const [connected, setConnected] = useState(navigator.onLine);
  const cached = !connected && wasAuthenticated() ? getCachedProfile() : null;
  const owner = (user?.email ?? cached?.email ?? '').toLowerCase();
  const current = useRef(owner);
  current.current = owner;
  useEffect(() => {
    current.current = owner;
    const changed = () => setConnected(navigator.onLine);
    window.addEventListener('online', changed);
    window.addEventListener('offline', changed);
    return () => {
      current.current = '';
      window.removeEventListener('online', changed);
      window.removeEventListener('offline', changed);
    };
  }, [owner]);
  const api = useMemo(
    () =>
      warehouseDevicesApi(
        () => !!owner && current.current === owner && !!getIdToken(),
      ),
    [owner],
  );
  if (!owner)
    return (
      <main className="warehouse">
        <h1>Geräte und Seriennummern</h1>
        {isLoading ? (
          <p>Anmeldung wird geprüft …</p>
        ) : (
          <>
            <p>Bitte anmelden, um den Lagerbestand zu öffnen.</p>
            <Link to="/login">Zur Anmeldung</Link>
          </>
        )}
      </main>
    );
  const key = `${location.origin}:devices:live:${owner}`;
  return <WarehouseDevicesScreen key={key} storageKey={key} api={api} />;
}
